<template>
  <div class="base-menu">



    <b-navbar class="navbarBg bottom-solid-line" toggleable="xl" type="dark">
      <div class="logoName" style="position: absolute;margin-left: 0px;font-size: 1.4rem;width: 100%;display: flex;align-items: center;">
        <img class="back" src="@/assets/images/back.png" alt="返回" @touchstart="back"  @click="back">
        <img :src="$ftpUrl + logo" style="max-height: 25px;margin-right: 10px;margin-top: -2px;margin-left: 17px;height: 100%" v-if="logo">
        <!--        <span>{{ projectName }}</span>-->
        <span class="font-weight-bold">{{ title }}</span>
      </div>

      <b-navbar-toggle class="collapseIcon" style="position:absolute;" target="nav-collapse"></b-navbar-toggle>

      <!--      菜单-->
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="m-auto collapseMenu" style="position:absolute;">
          <b-nav-item v-for="(item,index) in navBarMenu" :key="index" @touchstart="skip(item)"  @click="skip(item)"
                      class="nav-link" style="padding: 0;">
            <div
              style="min-width: 70px"
              class="text-center"
              :class="$route.path.startsWith(item.navUrl) && item.navUrl !== '/' ? 'router-link-exact-active' : ''">
              {{ item.name }}
            </div>
            <img src="../../../assets/images/basic_operations/menu/menu_select.png"
                 style="margin: calc(100% - 4.25rem) -10px 0;width: 90px"
                 v-if="$route.path.startsWith(item.navUrl) && item.navUrl !== '/'">
          </b-nav-item>
        </b-navbar-nav>

      </b-collapse>

      <common-menu @newPage="newPage" class="commonMenu" style="position:absolute;"></common-menu>

    </b-navbar>
  </div>
</template>

<script>
import {getSystematicByCodes} from "@/network/systematic";
import {getResourceList} from "@/network/resource";
import CommonMenu from "@/views/basic_operations/nav_bar/CommonMenu";

export default {
  name: "NavBar",
  components: {CommonMenu},
  data() {
    return {
      mainContentMenu: [],
      navBarMenu: [],
      projectName: '',
      title: '',
      logo: null,
      codes: ['platform_abbreviation', 'PC_terminal_logo', 'children_platform_title'],
    }
  },
  created() {
    this.getByCodes();
  },
  mounted() {
    getResourceList().then(res => {
      if (res.code === 0) {
        this.navBarMenu = res.data.resourceTrees.filter(item => item.navUrl === 'device-manager')[0].children
        // 在第一个菜单项后面插入"综合态势"菜单项
        if (this.navBarMenu && this.navBarMenu.length > 0) {
          this.navBarMenu.splice(1, 0, {
            name: '综合态势',
            navUrl: '/overview'
          })
        }
        // 再增加一个告警中心菜单项
        if (this.navBarMenu && this.navBarMenu.length > 0) {
          this.navBarMenu.splice(2, 0, {
            name: '告警中心',
            navUrl: '/realTime-alarm'
          })
        }
      }
    })
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    // 菜单跳转
    skip(item) {
      // if (item.parameters === '_blank') {
      //   this.newPage(item.navUrl);
      // } else {
      //   this.$router.push(item.navUrl);
      // }
      this.$router.push(item.navUrl);
    },
    // 新页面调转
    newPage(pageUrl) {
      window.open(pageUrl, '_blank');
      // this.$router.push(pageUrl);
    },
    getByCodes() {
      getSystematicByCodes(this.codes).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item.code === "platform_abbreviation") {
              this.projectName = item.val1;
            }
            if (item.code === "PC_terminal_logo") {
              this.logo = item.icon1;
            }
            if (item.code === "children_platform_title") {
              this.title = item.val1;
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.nav-link{
  padding: 7px 0;
}
.back {
  width: 36px;
  height: 36px;
  cursor: pointer;
}
.navbarBg {
  /* background-image: url("../../../../public/static/images/menus/menu_bg1.png"); */
  /* background-color: transparent; */
  /* background-size: 100% 55px; */
  height: 55px;
}

.navbarBg .title {
  font-weight: normal;
  font-size: 1.8rem;
  text-align: center;
  width: 100%;
  display: block;
}

.logoName {
  margin-top: -5px;
}

.menuDot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 2px;
}

.dot {
  background-color: #07E6F8;
}

.activeDot {
  background-color: #fff;
}

.collapseMenu {
  top: 9px;
  right: calc(120px + 1.5vw);
  background-color: transparent !important;
}
.commonMenu {
  top: 9px;
  right: 15px;
}
@media (max-width: 1198px) {
  .collapseIcon {
    top: 14px;
    right: 120px;
  }
  .collapse.show .collapseMenu{
    top: 48px;
    right: 100px;
    background-color: rgba(41, 155, 255, 0.3) !important;
  }

}

@media (max-width: 698px) {
  .navbarBg {
    height: 45px;
    background-image: none;
  }

  .logoName {
    top: 12px;
  }

  .collapseIcon {
    top: 10px;
  }

  .commonMenu {
    top: 10px;
  }
}
</style>
